import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { IconKey } from '@common/classes/icons';
import {
    AdministrationPermissions,
    BunkerListPermissions,
    CodeListPermissions,
    EventEvidencePermissions,
    PilotagePlanPermissions,
    PortPlanRevisionPermissions,
    ProtestPermissions,
    ReportsPermissions,
    VesselAnnouncementPermissions,
    VesselPermissions
} from '@common/classes/permissions';
import { PermissionType } from '@common/models/user';
import { PropertyFunction } from '@common/models/util.interface';
import { SVGIcon } from '@progress/kendo-svg-icons';

export interface NavItem extends PanelBarItemModel {
    readonly permissions?: PermissionType | PermissionType[];
}

export const NAVIGATION: NavItem[] = [
    // {
    //     title: _('Dashboard'),
    //     icon: 'faSolidInbox',
    //     path: '/dashboard',
    //     id: 'dashboard',
    //     selected: true
    // },
    {
        title: _('Port Koper Map'),
        icon: 'faSolidMapLocationDot',
        path: '/port-koper-map',
        id: 'port-kopper-map'
    },
    {
        title: _('Vessel Operation Control'),
        icon: 'faSolidBullhorn',
        path: '/vessel-announcement/list',
        permissions: [VesselAnnouncementPermissions.Default.List],
        id: 'vessel-announcement'
    },
    {
        title: _('Berth Planning With AI'),
        icon: 'faSolidWandMagicSparkles',
        path: '/berth-plan/list',
        permissions: [PortPlanRevisionPermissions.Default.List],
        id: 'berth-plan'
    },
    {
        title: _('Vessel Arrival'),
        icon: 'faSolidLocationDot',
        path: '/vessel-arrival/list',
        id: 'vessel-arrival'
    },
    // {
    //     title: _('Vessel Visits'),
    //     icon: 'faSolidLocationDot',
    //     path: '/vessel-visit/list',
    //     permissions: [VesselPermissions.VesselVisit.List],
    //     id: 'vessel-visit'
    // },
    {
        title: _('Pilotage plans'),
        icon: 'faSolidShip',
        path: '/pilotage-plans/list',
        permissions: [PilotagePlanPermissions.Default.List],
        id: 'pilotage-plans'
    },
    {
        title: _('Tug boats'),
        icon: 'faSolidShip',
        id: 'tugBoats',
        children: [
            {
                title: _('Tug boats list'),
                icon: 'faSolidShip',
                path: '/tug-boats/tugs',
                permissions: [VesselPermissions.Default.List],
                id: 'tug-boats-list'
            },
            {
                title: _('Bunkers'),
                icon: 'faSolidGasPump',
                path: '/tug-boats/bunkers',
                permissions: [VesselPermissions.Default.List],
                id: 'tug-boats-bunkers'
            },
            {
                title: _('Additional services'),
                icon: 'faSolidShip',
                path: '/tug-boats/additional-services',
                permissions: [VesselPermissions.Default.List],
                id: 'tug-boats-additional-services'
            }
        ]
    },
    {
        title: _('Event evidence'),
        icon: 'faSolidFileLines',
        path: '/event-evidence/list',
        permissions: [EventEvidencePermissions.Default.List],
        id: 'event-evidence'
    },
    {
        title: _('Near event evidence'),
        icon: 'faSolidFileLines',
        path: '/near-event-evidence/list',
        permissions: [EventEvidencePermissions.Default.List],
        id: 'event-evidence'
    },
    {
        title: _('Bunkers'),
        icon: 'faSolidGasPump',
        path: '/bunkers/list',
        permissions: [BunkerListPermissions.Default.List],
        id: 'bunkers'
    },
    {
        title: _('Protests'),
        icon: 'faSolidFile',
        path: '/protests/list',
        permissions: [ProtestPermissions.Default.List],
        id: 'protests'
    },
    {
        title: _('Vessels'),
        icon: 'faSolidShip',
        path: '/vessels/list',
        permissions: [VesselPermissions.Default.List],
        id: 'vessels'
    },
    {
        title: _('Reports'),
        icon: 'faSolidFileExcel',
        id: 'reports',
        children: [
            {
                title: _('Monthly plans'),
                icon: 'faSolidCalendarCheck',
                path: 'monthly-plans/list',
                permissions: [ReportsPermissions.MonthlyPlans.List],
                id: 'monhtly-plans'
            },
            {
                title: _('Esi points'),
                icon: 'faSolidFileContract',
                path: '/reports/esi-reports',
                permissions: [ReportsPermissions.EsiPoints.List],
                id: 'reportsEsi'
            },
            {
                title: _('Bunkers'),
                icon: 'faSolidGasPump',
                path: '/reports/bunker-reports',
                permissions: [ReportsPermissions.Bunkers.List],
                id: 'reportsBunkers'
            },
            {
                title: _('Movements'),
                icon: 'faSolidShip',
                path: 'reports/movement-reports',
                permissions: [ReportsPermissions.Movements.List],
                id: 'reportsMovements'
            },
            {
                title: _('Vessels on anchor'),
                icon: 'faSolidAnchor',
                path: 'reports/vessels-anchor',
                permissions: [ReportsPermissions.VesselsOnAnchor.List],
                id: 'reportsVesselsOnAnchor'
            },
            {
                title: _('Vessel number'),
                icon: 'faSolidRectangleList',
                path: 'reports/vessel-number',
                permissions: [ReportsPermissions.VesselNumber.List],
                id: 'reportsVesselNumber'
            },
            {
                title: _('Protests'),
                icon: 'faSolidFile',
                path: 'reports/protest-reports',
                permissions: [ReportsPermissions.Protests.List],
                id: 'reportsProtestReports'
            },
            {
                title: _('Voyages'),
                icon: 'faSolidShip',
                path: 'reports/voyage-reports',
                permissions: [ReportsPermissions.Voyages.List],
                id: 'reportsVoyageReports'
            },
            {
                title: _('Anchorage + Voyage'),
                icon: 'faSolidAnchorCircleCheck',
                path: 'reports/anchorage-voyage-reports',
                permissions: [ReportsPermissions.AnchorVoyage.List],
                id: 'reportsAnchorageVoyage'
            }
        ]
    },
    {
        title: _('Administration'),
        icon: 'faSolidGear',
        id: 'administration',
        children: [
            {
                title: _('Message logs'),
                icon: 'faSolidList',
                path: '/administration/message-logs',
                permissions: [AdministrationPermissions.MessageLogs.List],
                id: 'adminMessageLogs'
            },
            {
                title: _('Previous Weather Warnings'),
                icon: 'faSolidCloudSun',
                path: '/administration/previous-weather-warnings',
                id: 'adminPreviousWeatherWarnings'
            },
            {
                title: _('Roles'),
                icon: 'faSolidKey',
                path: '/administration/role',
                permissions: [AdministrationPermissions.Role.ViewAll],
                id: 'adminRoles'
            },
            {
                title: _('Codelists'),
                icon: 'faSolidList',
                path: '/administration/codelists',
                permissions: [CodeListPermissions.View.List],
                id: 'codelists'
            },
            {
                title: _('Users'),
                icon: 'faSolidUsers',
                permissions: [AdministrationPermissions.User.ViewAll],
                path: '/administration/user',
                id: 'adminUsers'
            },
            {
                title: _('Organizations'),
                icon: 'faSolidBuilding',
                path: '/administration/organization',
                permissions: [AdministrationPermissions.Organization.ViewAll],
                id: 'adminOrganizations'
            }
        ]
    }
];

const flatten = (members: NavItem[]): NavItem[] => {
    let children = [];

    return members
        .map((m) => {
            if (m.children && m.children.length) {
                children = [...children, ...m.children];
            }
            return m;
        })
        .concat(children.length ? flatten(children) : children);
};

export const NAVIGATION_FLAT = flatten(NAVIGATION);

export interface PanelBarItemModel {
    // Sets the title of the PanelBar item.
    title: string;

    // Allows the component to set the `"id"` property of each item.
    id: string;

    //Defines the icon that will be rendered next to the title.
    icon: IconKey;

    // Defines the icon that will be rendered next to the title by using a custom CSS class.
    iconClass?: string;

    // Defines an SVGIcon to be rendered.
    // The input can take either an [existing Kendo SVG icon](slug:svgicon_list) or a custom one.
    svgIcon?: SVGIcon;

    // Defines the location of the image that will be displayed next to the title.
    imageUrl?: string;

    // When set to `true`, disables a PanelBar item.
    disabled?: boolean;

    // When set to `true`, expands the PanelBar item.
    expanded?: boolean;

    // Sets the focused state of a PanelBar item.
    focused?: boolean;

    // Sets the selected state of a PanelBar item.
    selected?: boolean;

    // Specifies if the item will be hidden.
    hidden?: boolean | PropertyFunction<boolean>;

    // Defines the child items as an array.
    children?: PanelBarItemModel[];

    // Sets the content of the PanelBar item.
    content?: any;

    // Sets permissions for the PanelBar item.
    readonly permissions?: PermissionType | PermissionType[];

    // Sets the path of the PanelBar item.
    path?: string;
}
